const userCheck = (name: string, defaultValue: string) => {
  return name.length > 0 ? name : defaultValue
}

export default userCheck
